import React from 'react';
import Icon from 'icon';

import s from './icons.module.scss';

export default function AsideIcons({ icons }) {
  return (
    <div className={s.wrapper}>
      {icons.map(({ icon, href }) => (
        <a key={icon} href={`${href}`}>
          <Icon icon={icon} />
        </a>
      ))}
    </div>
  );
}
